export enum RequiredHeadersEnum {
  X_OP_MODULE = 'x-op-module',
  X_OP_EVENT = 'x-op-event',
  X_EVENT_ID = 'x-event-id',
  X_OP_MESSAGE = 'x-op-message'
}
